document.addEventListener('DOMContentLoaded', () => {
  const pdpUpsellPopup = document.querySelector('.pdp-upsell-popup');
  
  if (pdpUpsellPopup.hasAttribute('data-show-one-time')) {
    const productId = pdpUpsellPopup.dataset.productId;
    const shownPopups = JSON.parse(sessionStorage.getItem('shownUpsellPopups') || '[]');
    
    if (shownPopups.includes(productId)) {
      return;
    }
    
    shownPopups.push(productId);
    sessionStorage.setItem('shownUpsellPopups', JSON.stringify(shownPopups));
  }

  const upsellPopupTrigger = document.querySelectorAll('.upsell-popup-trigger');
  const upsellPopupForm = document.querySelector('.pdp-upsell-popup__submit');
  let pendingButtonClick = null;
  let clickHandler = null;

  upsellPopupTrigger.forEach(trigger => {
    clickHandler = (event) => {
      const isTriggerOrChild = event.target.closest('.upsell-popup-trigger') === trigger;
      if (!isTriggerOrChild) return;

      event.preventDefault();
      pendingButtonClick = trigger;
      pdpUpsellPopup.classList.add('active');
      document.body.classList.add('overflow-hidden');
    };
    trigger.addEventListener('click', clickHandler);
  });
  
  const closeBtn = pdpUpsellPopup.querySelector('.pdp-upsell-popup__close-btn');

  const closePopup = () => {
    pdpUpsellPopup.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    upsellPopupTrigger.forEach(trigger => {
      trigger.classList.remove('upsell-popup-trigger');
    });

    if (pendingButtonClick) {
      pendingButtonClick.removeEventListener('click', clickHandler);
      pendingButtonClick.click();
      pendingButtonClick = null;
    }
  };
  
  closeBtn.addEventListener('click', closePopup);

  pdpUpsellPopup.addEventListener('click', (event) => {
    const isWrapperOrChild = event.target.closest('.pdp-upsell-popup__wrapper');
    if (!isWrapperOrChild && event.target === pdpUpsellPopup) {
      closePopup();
    }
  });

  upsellPopupForm.addEventListener('click', (event) => {
    const qnt = document.querySelector('.pdp-upsell-popup__form .quantity__input').value;

    let formData = {
      'items': [{
        'id': upsellPopupForm.dataset.id,
        'quantity': qnt
      }]
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      pdpUpsellPopup.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      upsellPopupTrigger.forEach(trigger => {
        trigger.classList.remove('upsell-popup-trigger');
      });

      if (pendingButtonClick) {
        pendingButtonClick.removeEventListener('click', clickHandler);
        pendingButtonClick.click();
        pendingButtonClick = null;
      }

      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });
});